<div class="card border-0 header">
  <h4 class="card-header text-uppercase">E-mail em Lote</h4>
  <div style="padding: 20px">
    <!-- Filters -->
    <div class="row mr-2">
      <div class="form-group col-md-3">
        <label class="col-2">Grupo</label>
        <select
          class="form-control"
          id="filterGroupType"
          [(ngModel)]="filterGroupType"
          name="filterGroupType"
        >
          <option selected="selected" value="0">Todos</option>
          <option *ngFor="let group of groupsList" [value]="group.id">
            {{ group.name }}
          </option>
        </select>
      </div>
      <div style="padding-top: 24px" class="col-md mb-2">
        <button
          type="button"
          class="btn btn-primary btn-block"
          (click)="getEmails()"
        >
          Selecionar E-mails
        </button>
      </div>
    </div>
    <!-- / Filters -->

    <div>
      <div class="form-group col-md-12">
        <label class="col-2">Lista de e-mails*</label>
        <textarea
          class="form-control"
          rows="4"
          placeholder="Utilize o botão 'Selecionar E-mails' ou digite os e-mails separados por vírgula. Lembrando que o sistema só envia e-mails para usuários cadastrados."
          [(ngModel)]="emailsList"
          id="emailsList"
          name="emailsList"
          style="white-space: pre-wrap"
        ></textarea>
      </div>

      <div style="padding-top: 20px" class="form-group col-md-4">
        <label class="col-2">Assunto*</label>
        <input
          class="form-control"
          placeholder="Assunto"
          type="text"
          [(ngModel)]="emailSubject"
        />
      </div>
      <div style="padding-top: 10px">
        <div>
          <label class="col-2">Corpo do e-mail*</label>
        </div>
        <quill-editor
          [(ngModel)]="emailText"
          placeholder="Digite o texto aqui..."
        >
          <div quill-editor-toolbar>
            <span class="ql-formats">
              <select class="ql-font"></select>
              <select class="ql-size"></select>
            </span>
            <span class="ql-formats">
              <button class="ql-bold"></button>
              <button class="ql-italic"></button>
              <button class="ql-underline"></button>
              <button class="ql-strike"></button>
            </span>
            <span class="ql-formats">
              <select class="ql-color"></select>
              <select class="ql-background"></select>
            </span>
            <span class="ql-formats">
              <button class="ql-script" value="sub"></button>
              <button class="ql-script" value="super"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-header" value="1"></button>
              <button class="ql-header" value="2"></button>
              <button class="ql-blockquote"></button>
              <button class="ql-code-block"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered"></button>
              <button class="ql-list" value="bullet"></button>
              <button class="ql-indent" value="-1"></button>
              <button class="ql-indent" value="+1"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-direction" value="rtl"></button>
              <select class="ql-align"></select>
            </span>
            <span class="ql-formats">
              <button class="ql-link"></button>
              <!-- <button class="ql-image"></button>
              <button class="ql-video"></button> -->
            </span>
            <span class="ql-formats">
              <button class="ql-clean"></button>
            </span>
          </div>
        </quill-editor>
      </div>
    </div>

    <div class="text-right mt-3">
      <button
        type="button"
        [disabled]="sendButtonDisabled()"
        class="btn btn-primary"
        (click)="sendEmail()"
      >
        Enviar e-mails
      </button>
    </div>
  </div>
</div>
